var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t-btn _green _big",on:{"click":function($event){return _vm.openCookieSettingModal()}}},[_vm._v(_vm._s(_vm.$root.staticText.cookies.editCookie))])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/templates/components/ui-components/banner/components/CookeModalBtn.vue?vue&type=template&id=0b624695&
// module id = 1216
// module chunks = 0